<div class="section">
    <article class="" #ckeditor id="ckeditor" [ngSwitch]="item.itemConfigType" [ngClass]="{'disabled' : statusId !== countryDataStatus.Draft || !canEdit}">
        <label [ngClass]="getTitleClass()">
            {{item.name}}
            <i (click)="showLiveAudit(item.itemDetail)" *ngIf="statusId == countryDataStatus.Draft && differentFromLive(item.itemDetail)" class="fa fa-history text-info ml-1 d-inline clickable" role="button" title="View current published information" style="cursor: pointer;">
            </i>
        </label>
        <div class="editor p-0" (click)="onInitiateChanges()">
            <ng-container *ngSwitchCase="itemConfigType.CategoryItemConfig">
                <div *ngIf="!this.editMode && item.itemDetail.value" [innerHTML]="item.itemDetail.value" class="p-3"></div>

                <div *ngIf="!this.editMode && !item.itemDetail.value" class="p-3"><em>No content</em></div>

                <div *ngIf="this.editMode">
                    <ckeditor [editor]="Editor" [(ngModel)]="item.itemDetail.value" [config]="config" (change)="itemValueChanged($event)" ckEditorEnhanced></ckeditor>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="itemConfigType.HtmlTextItemConfig">

                <div *ngIf="!this.editMode && item.itemDetail.value" [innerHTML]="item.itemDetail.value" class="p-3"></div>

                <div *ngIf="!this.editMode && !item.itemDetail.value" class="p-3"><em>No content</em></div>

                <div *ngIf="this.editMode">
                    <ckeditor [editor]="Editor" [(ngModel)]="item.itemDetail.value" [config]="config" (change)="itemValueChanged($event)" [ckEditorEnhanced]="Editor"></ckeditor>
                </div>

            </ng-container>
            <ng-container *ngSwitchCase="itemConfigType.DateItemConfig">
                <div *ngIf="!this.editMode && item.itemDetail.value" class="p-3">
                    {{item.itemDetail.value | date : 'd/MMMM/y' }}
                </div>
                <div *ngIf="!this.editMode && !item.itemDetail.value" class="p-3"><em>No content</em></div>
                <div *ngIf="this.editMode">
                    <input type="date" class="form-control" [(ngModel)]="item.itemDetail.value" placeholder="dd-mm-yyyy" (change)="itemValueChanged($event)" />
                </div>

            </ng-container>
            <ng-container *ngSwitchCase="itemConfigType.DropdownItemConfig">
                <div *ngIf="!this.editMode && item.itemDetail.value" class="p-3">
                    <ng-container *ngIf="item.allowMultiple; then showMultiple else showSingle"></ng-container>
                    <ng-template #showSingle>{{selectedDropdownItem.text }}</ng-template>
                    <ng-template #showMultiple>{{multipleSelectionString}}</ng-template>  
                </div>

                <div *ngIf="!this.editMode && !item.itemDetail.value" class="p-3"><em>No content</em></div>

                <div *ngIf="this.editMode">
                    <ng-container *ngIf="item.allowMultiple; then ddMultiple else ddSingle"></ng-container>
                    <ng-template #ddSingle>
                        <ng-select [allowClear]="true"
                                   [items]="dropdownItems"
                                   (selected)="onDropDownItemSelected($event)"
                                   (removed)="resetDropDown()"
                                   placeholder="No item selected"
                                   [active]="[selectedDropdownItem]">
                        </ng-select>
                    </ng-template>

                    <ng-template #ddMultiple>
                        <ng-select [allowClear]="true"
                                   [multiple]="true"
                                   [items]="dropdownItems"
                                   (selected)="onDropDownMultipleItemSelected($event)"
                                   (removed)="clearMultipleSelection()"
                                   placeholder="No item selected"
                                   [active]="multipleSelectedDropdownItems">
                        </ng-select>
                    </ng-template>
                </div>

            </ng-container>
        </div>
            <metadataitemselector *ngIf="itemMetadata?.length > 0 && item.itemDetail.value" [availableMetaItems]="itemMetadata" [item]="item" [editMode]="statusId === countryDataStatus.Draft"></metadataitemselector>
    </article>
    <div class="section ml-4">
        <ng-container *ngFor="let item of items; let i = index">
            <itemconfigmanagementitem [liveItems]="liveItems" [dropdowns]="dropdowns" [item]="item" [items]="item?.children" [depth]="depth+1" [statusId]="statusId" [canEdit]="canEdit"></itemconfigmanagementitem>
        </ng-container>
    </div>
</div>
<htmlcontentmodal #htmlcontentmodal [originalItem]="selectedItemDetailLiveItem" [currentItem]="selectedItemDetailCurrentItem"></htmlcontentmodal>
